<template>
  <v-card>
    <v-dialog v-model="employee" v-if="employee"
              lazy
              max-width="600"
              @input="v => v || restoreEmployeeForm()">
      <v-card class="pa-4">
        <v-layout column>
          <span class="title pb-2">Edit Employee: {{employee.userName}}</span>
          <v-flex>
            <span class="mt-2 subheadline accent--text">Permissions</span>
            <v-icon small @click="openPermissionsHelp = true" class="pl-3">help</v-icon>
          </v-flex>
          <v-layout row wrap>
            <v-flex sm6>
              <v-checkbox label="Admin"
                          v-model="employee.companyPermissions"
                          value="PERM_ADMIN"/>
            </v-flex>
            <v-flex sm6>
              <v-checkbox label="Receiving"
                          value="PERM_RECEIVING"
                          v-model="employee.companyPermissions"/>
            </v-flex>
            <v-flex sm6>
              <v-checkbox label="Financial"
                          value="PERM_FINANCIAL"
                          v-model="employee.companyPermissions"/>
            </v-flex>
            <v-flex sm6>
              <v-checkbox label="Office"
                          value="PERM_OFFICE"
                          v-model="employee.companyPermissions"/>
            </v-flex>
            <v-flex sm6>
<!--              <v-checkbox label="Buyer"-->
<!--                          value="PERM_CREATE_LISTING"-->
<!--                          v-model="employee.companyPermissions"/>-->
            </v-flex>
            <v-flex sm6>
              <v-checkbox label="Dispatched Driver"
                          value="PERM_DRIVER"
                          v-model="employee.companyPermissions"/>
            </v-flex>
            <v-flex sm6>
              <v-checkbox label="Direct Assign"
                          value="PERM_LOAD_ASSIGN"
                          v-if="isLtnAdmin"
                          v-model="employee.companyPermissions"/>
            </v-flex>
          </v-layout>
          <v-card-actions>
            <v-spacer />
            <v-btn color="accent" @click="saveEmployee">Save</v-btn>
            <v-btn color="accent" flat @click="employee = null">Cancel</v-btn>
          </v-card-actions>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-toolbar flat dense extended color="white" class="darken-1">
      <v-toolbar-title>Team & Permissions</v-toolbar-title>
      <v-spacer/>
      <v-toolbar-items>
        <v-btn color="primary"
               @click="$emit('add-new')">
          <v-layout column>
            <v-icon color="white">person_add_alt_1</v-icon>
            <span>Add to Team</span>
          </v-layout>
        </v-btn>
      </v-toolbar-items>

      <template v-slot:extension>
        <v-text-field v-model="searchTerm"
                      class="mx-3"
                      append-icon="search"
                      placeholder="Search for an employee"/>
        <v-spacer/>
      </template>
    </v-toolbar>
    <v-card flat class="pb-4">
      <v-card v-if="$vuetify.breakpoint.smAndDown" v-for="employee in company.employees" :key="employee.id" class="xs12 my-2">

              <v-card-title>
                <v-layout column>
                  <h6 class="title">
                    {{ employee.userName }}
                    <span v-if="employee.userId === userProfile.id">
                      &nbsp; (You)
                    </span>
                  </h6>
                </v-layout>
              </v-card-title>

              <v-card-text>
                <b>Email:</b> {{employee.contactEmail}}<br/>
                <b>Permissions:</b> {{employee.companyPermissions ?
                employee.companyPermissions.join(', ') : null}}<br/>
                <b>CDL Expiration:</b> {{_.get(employee, 'driverProfile.cdlExpires', null)}}<br/>
                <b>Medical Endorsement Expiration: </b>
                {{_.get(employee, 'driverProfile.medicalExpires', null)}}<br/>
                <v-layout row wrap>
                  <v-flex>
                    <v-btn flat small color="primary" v-if="isAdmin"
                           @click="editEmployee(employee)">Edit</v-btn>
                  </v-flex>
                  <v-flex>
                    <v-btn flat small color="accent" v-if="isAdmin"
                           @click="removeEmployee(employee.userId,
                            employee.userName || employee.contactEmail)">
                      Remove
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          <v-data-table v-if="$vuetify.breakpoint.smAndUp"
                        :headers="headers"
                        disable-initial-sort
                        item-key="userId"
                        :items="company.employees"
                        :search="searchTerm">
            <template slot="items" slot-scope="slotItems">
                <td>
                  <v-toolbar-items class="mx-0 px-0">
                    <v-btn flat small color="primary" v-if="isAdmin"
                           @click="editEmployee(slotItems.item)">Edit</v-btn>
                    <v-btn flat small color="accent" v-if="isAdmin"
                           @click="removeEmployee(slotItems.item.userId,
                            slotItems.item.userName || slotItems.item.contactEmail)">
                      Remove
                    </v-btn>
                  </v-toolbar-items>
                </td>
                <td @click="expandRow(slotItems)">
                  <v-layout row>
                    {{ slotItems.item.userName }}
                    <span v-if="slotItems.item.userId === userProfile.id">
                      &nbsp; (You)
                    </span>
                  </v-layout>
                  <v-list-tile-action-text>{{slotItems.item.contactEmail}}</v-list-tile-action-text>
                </td>
                <td @click="expandRow(slotItems)">
                  {{slotItems.item.companyPermissions ?
                  slotItems.item.companyPermissions.join(', ') : null}}
                </td>
                <td @click="expandRow(slotItems)">
                  {{_.get(slotItems, 'item.driverProfile.cdlExpires', null)}}
                </td>
                <td @click="expandRow(slotItems)">
                  {{_.get(slotItems, 'item.driverProfile.medicalExpires', null)}}
                </td>
                <td @click="expandRow(slotItems)"/>
            </template>
            <template slot="expand" v-if="isLtnAdmin" slot-scope="slotItems">
              <v-card>
                <v-layout wrap>
                  <v-btn flat class="text-capitalize"
                         :to="{ name: 'notification-settings',
                   query: { userId: slotItems.item.userId }}">
                    Notifications Settings
                  </v-btn>
                  <v-btn flat class="text-capitalize"
                         :to="{ name: 'profile',
                         params: { userId: slotItems.item.userId }}">
                    Profile
                  </v-btn>
                </v-layout>
              </v-card>
              <user-expand :user-id="slotItems.item.userId"></user-expand>
            </template>
          </v-data-table>
    </v-card>
  </v-card>
</template>

<script>
import _ from 'lodash';
import API from '@/api';
import { mapState, mapGetters } from 'vuex';

import UserExpand from '@/components/UserExpand';

export default {
  name: 'EmployeesSection',
  props: {
    isAdmin: {
      type: Boolean,
    },
    company: {
      type: Object,
    },
  },
  components: {
    UserExpand,
  },
  data() {
    return {
      searchTerm: null,
      employee: null,
      headers: [
        { align: 'left', text: ' ', value: 'action-buttons', sortable: false, width: "1%" },
        { align: 'left', text: 'Name and Email', value: 'userName', width: "1%" },
        { align: 'left', text: 'Permissions', value: 'Permissions', sortable: false, width: "1%" },
        { align: 'left', text: 'CDL Expiration', value: 'expiration', sortable: false, width: "1%" },
        { align: 'left', text: 'Medical Endorsement Expiration', value: 'endorsement-exp', sortable: false, width: "1%" },
        { align: 'left', text: ' '}
      ],
    };
  },
  computed: {
    _() {
      return _;
    },
    ...mapState('profiles', {
      userProfile: 'userProfile',
    }),
    ...mapGetters('profiles', {
      isLtnAdmin: 'isLtnAdmin',
    }),
  },
  methods: {
    expandRow(slotItems) {
      if (this.isLtnAdmin) {
        slotItems.expanded = !slotItems.expanded;
      }
    },
    async saveEmployee() {
      try {
        await API.company.updateEmployeePermissions({
          companyId: this.company.id,
          userId: this.employee.userId,
          body: { permissions: this.employee.companyPermissions },
        });
        this.$emit('refresh');

        this.employee = null;
        this.$store.dispatch('applications/setSuccessNotification', {
          message: 'Employee updated',
          timeout: 7000,
        });
      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: error.message,
        });
      }
    },
    editEmployee(employee) {
      this.employee = _.cloneDeep(employee);
    },
    restoreEmployeeForm() {
      this.employee = null;
    },
    async removeEmployee(id, employeeName) {
      const confirmation = await this.$confirm(`Do you really want to remove ${employeeName}?`);
      if (!confirmation) {
        return;
      }

      try {
        await API.company.deleteEmployee({ companyId: this.company.id, userId: id });
        this.$emit('refresh');
      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: error.message,
        });
      }
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Companies/Sections/EmployeesSection.vue